{
  "app": {
    "name": "IoT Edge",
    "description": "Smart IoT Monitoring & Management Platform"
  },
  "login": {
    "title": "Login",
    "email": "Email",
    "email_placeholder": "example@domain.com",
    "password": "Password",
    "online": "Online",
    "password_placeholder": "Enter your password",
    "submit": "Login",
    "remember_me": "Remember me",
    "or": "Or",
    "biometric_login": "Login with {{type}}",
    "face_id": "Face ID",
    "fingerprint": "Fingerprint",
    "connected": "Connected",
    "version": "Version",
    "biometric_failed": "Biometric Authentication Failed",
    "use_password": "Please use your password",
    "biometric_no_credentials_title": "No saved credentials",
    "biometric_no_credentials_message": "Please login with password first",
    "validation": "Please enter email and password",
    "invalidEmail": "Please enter a valid email address",
    "failed": "Login failed",
    "tooManyAttempts": "Too many login attempts",
    "rateLimitMessage": "Please wait before trying again",
    "show_password": "Show password",
    "hide_password": "Hide password",
    "toggle_password_visibility": "Toggle password visibility",
    "remember_me_hint": "Save email address for next time",
    "submit_hint": "Log in to your account"
  },
  "common": {
    "loading": "Loading...",
    "error": "An error occurred",
    "success": "Operation completed successfully",
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete",
    "edit": "Edit",
    "add": "Add",
    "search": "Search",
    "filter": "Filter",
    "refresh": "Refresh",
    "confirm": "Confirm",
    "yes": "Yes",
    "no": "No",
    "ok": "OK",
    "back": "Back",
    "next": "Next",
    "submit": "Submit",
    "logout": "Logout",
    "profile": "Profile",
    "settings": "Settings",
    "unknown_organization": "Unknown Organization"
  },
  "auth": {
    "login": "Login",
    "loginTitle": "Login to your account",
    "email": "Email",
    "password": "Password",
    "rememberMe": "Remember me",
    "forgotPassword": "Forgot password?",
    "loginSuccess": "Login successful",
    "loginError": "Invalid email or password",
    "emailRequired": "Email is required",
    "passwordRequired": "Password is required"
  },
  "navigation": {
    "dashboard": "Dashboard",
    "devices": "Devices",
    "alarms": "Alarms",
    "sites": "Sites",
    "zones": "Zones",
    "users": "Users",
    "reports": "Reports",
    "profile": "Profile",
    "deviceDetail": "Device Details",
    "alarmRules": "Alarm Rules",
    "editDevice": "Edit Device",
    "addDevice": "Add Device",
    "qrScanner": "QR Scanner",
    "reportOptions": "Report Options",
    "customTemplates": "Custom Templates",
    "notificationSettings": "Notification Settings",
    "sitesManagement": "Sites Management",
    "zonesManagement": "Zones Management",
    "usersManagement": "Users Management",
    "settings": "Settings"
  },
  "dashboard": {
    "title": "Dashboard",
    "welcome": "Welcome",
    "totalDevices": "Total Devices",
    "activeDevices": "Active Devices",
    "offlineDevices": "Offline Devices",
    "criticalAlarms": "Critical Alarms",
    "recentActivity": "Recent Activity",
    "statistics": "Statistics",
    "quickActions": "Quick Actions",
    "keyMetrics": "Key Metrics",
    "recentAlarms": "Recent Alarms",
    "critical": "Critical",
    "offline": "Offline",
    "online": "Online",
    "total": "Total",
    "now": "Now",
    "minuteAgo": "1 minute ago",
    "minutesAgo": "{{count}} min ago",
    "hourAgo": "1 hour ago",
    "hoursAgo": "{{count}}h ago",
    "dayAgo": "1 day ago",
    "daysAgo": "{{count}} days ago",
    "systemOperational": "System is operating normally",
    "systemAttention": "System needs attention",
    "systemCritical": "System is in critical state"
  },
  "devices": {
    "title": "Devices",
    "addDevice": "Add Device",
    "editDevice": "Edit Device",
    "deleteDevice": "Delete Device",
    "deviceName": "Device Name",
    "deviceId": "Device ID",
    "deviceType": "Device Type",
    "status": "Status",
    "location": "Location",
    "zone": "Zone",
    "lastSeen": "Last Seen",
    "online": "Online",
    "offline": "Offline",
    "battery": "Battery",
    "signal": "Signal",
    "deleteConfirm": "Are you sure you want to delete this device?",
    "noDevices": "No devices found",
    "searchDevices": "Search devices",
    "filterByZone": "Filter by zone",
    "filterByStatus": "Filter by status",
    "all": "All",
    "organization": "Organization",
    "role": "Role",
    "user": "User",
    "scanQRCode": "Scan QR Code",
    "scannedSuccessfully": "Scanned Successfully",
    "formFilledFromQR": "Form filled from QR code",
    "deviceAdded": "Device added successfully",
    "mqttCredentials": "MQTT Credentials",
    "username": "Username",
    "password": "Password",
    "enterDeviceName": "Please enter device name",
    "selectSiteAndZone": "Please select site and zone",
    "savingDevice": "Saving device...",
    "changesSaved": "Changes saved successfully",
    "failedToSave": "Failed to save device",
    "failedToLoad": "Failed to load device data",
    "hasBattery": "Has Battery",
    "alarmRulesTemplate": "Alarm Rules Template",
    "selectTemplate": "Select Alarm Rules Template",
    "noTemplate": "None (can add later)",
    "templateApplied": "Alarm template applied",
    "rulesCount": "rules",
    "canAddLater": "Can add alarm rules later",
    "deviceTypes": {
      "SENSOR": "Generic Sensor",
      "TEMPERATURE": "Temperature Sensor",
      "HUMIDITY": "Humidity Sensor",
      "TEMP_HUMIDITY": "Temp & Humidity",
      "LEVEL": "Level Sensor",
      "ENERGY": "Energy Meter",
      "POWER": "Power Meter",
      "WATER": "Water Meter",
      "GAS": "Gas Meter",
      "MOTION": "Motion Sensor",
      "DOOR": "Door Sensor",
      "CAMERA": "Camera",
      "ACTUATOR": "Actuator",
      "MULTI_SENSOR": "Multi-Sensor"
    }
  },
  "alarms": {
    "title": "Alarms",
    "noAlarms": "No alarms found",
    "critical": "Critical",
    "warning": "Warning",
    "info": "Info",
    "acknowledged": "Acknowledged",
    "unacknowledged": "Unacknowledged",
    "acknowledge": "Mark as read",
    "alarmType": "Alarm Type",
    "device": "Device",
    "timestamp": "Timestamp",
    "message": "Message",
    "priority": "Priority",
    "filterBySeverity": "Filter by severity",
    "filterByStatus": "Filter by status"
  },
  "customTemplates": {
    "title": "Custom Alarm Templates",
    "subtitle": "Your organization alarm templates",
    "create": "Create New Template",
    "edit": "Edit Template",
    "delete": "Delete Template",
    "save": "Save Template",
    "noTemplates": "No Custom Templates",
    "emptyMessage": "Tap + to create a custom alarm template",
    "nameEnglish": "Name (English)",
    "nameArabic": "Name (Arabic)",
    "descriptionEnglish": "Description (English)",
    "descriptionArabic": "Description (Arabic)",
    "category": "Category",
    "pharmaceutical": "Pharmaceutical",
    "medical": "Medical",
    "laboratory": "Laboratory",
    "active": "Active",
    "rules": "Rules",
    "addRule": "Add Rule",
    "rule": "Rule",
    "type": "Type",
    "temperature": "Temperature",
    "humidity": "Humidity",
    "battery": "Battery",
    "severity": "Severity",
    "critical": "Critical",
    "warning": "Warning",
    "info": "Info",
    "lowThreshold": "Low Threshold",
    "highThreshold": "High Threshold",
    "hysteresis": "Hysteresis",
    "debounce": "Debounce (s)",
    "cooldown": "Cooldown (s)",
    "noRules": "No rules. Click \"Add Rule\" to start",
    "confirmDelete": "Confirm Delete",
    "deleteMessage": "Are you sure you want to delete \"{{name}}\"?",
    "saveSuccess": "Template saved successfully",
    "saveFailed": "Failed to save template",
    "deleteSuccess": "Template deleted",
    "deleteFailed": "Failed to delete template",
    "loadFailed": "Failed to load custom templates",
    "nameRequired": "Please enter template name in both languages",
    "rulesRequired": "Please add at least one rule",
    "rulesCount": "{{count}} rules"
  },
  "sites": {
    "title": "Sites",
    "addSite": "Add Site",
    "editSite": "Edit Site",
    "deleteSite": "Delete Site",
    "siteName": "Site Name",
    "address": "Address",
    "description": "Description",
    "zonesCount": "Zones Count",
    "devicesCount": "Devices Count",
    "noSites": "No sites found",
    "deleteConfirm": "Are you sure you want to delete this site?"
  },
  "zones": {
    "title": "Zones",
    "addZone": "Add Zone",
    "editZone": "Edit Zone",
    "deleteZone": "Delete Zone",
    "zoneName": "Zone Name",
    "site": "Site",
    "description": "Description",
    "devicesCount": "Devices Count",
    "noZones": "No zones found",
    "deleteConfirm": "Are you sure you want to delete this zone?",
    "selectSite": "Select Site",
    "medicalProfile": "Medical Profile",
    "selectProfile": "Select Profile",
    "temperatureRange": "Temperature Range",
    "humidityRange": "Humidity Range",
    "pressureRange": "Pressure Range"
  },
  "pressure": {
    "differentialPressure": "Differential Pressure",
    "pressureUnit": "Pa",
    "positivePressure": "Positive Pressure",
    "negativePressure": "Negative Pressure",
    "normalPressure": "Normal",
    "highPressure": "High Pressure",
    "lowPressure": "Low Pressure"
  },
  "medicalProfiles": {
    "title": "Medical Profiles",
    "refrigeratorMeds": "Pharmaceutical Refrigerator (2-8°C)",
    "refrigeratorVaccines": "Vaccine Cold Chain Refrigerator (2-8°C)",
    "freezerVaccines": "Vaccine Freezer (-25 to -15°C)",
    "deepFreezer": "Deep Freezer for Samples (-80 to -60°C)",
    "bloodBank": "Blood Bank (1-6°C)",
    "frozenPlasma": "Frozen Plasma (-30 to -20°C)",
    "pharmacyStorage": "Pharmacy - General Storage (15-25°C)",
    "medsWarehouse": "Medication Warehouse (15-25°C)",
    "controlledMeds": "Controlled Medications Room (15-25°C)",
    "operatingRoom": "Operating Room (20-24°C)",
    "icu": "Intensive Care Unit (20-24°C)",
    "patientRoom": "Patient Room (20-24°C)",
    "isolationRoom": "Isolation Room (20-24°C)",
    "neonatalIncubator": "Neonatal Incubator (24-26°C)",
    "clinicalLab": "Clinical Laboratory (18-25°C)",
    "pathologyLab": "Pathology Laboratory (18-24°C)",
    "medicalEquipment": "Sensitive Medical Equipment Room (18-24°C)",
    "biochemistryLab": "Biochemistry Laboratory (20-25°C)",
    "mriRoom": "MRI Equipment Room (18-22°C)",
    "serverRoom": "IT Server Room (18-24°C)",
    "sterilizationRoom": "Central Sterilization Room (18-22°C)"
  },
  "users": {
    "title": "User Management",
    "addUser": "Add User",
    "editUser": "Edit User",
    "deleteUser": "Delete User",
    "userName": "User Name",
    "email": "Email",
    "role": "Role",
    "permissions": "Permissions",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "noUsers": "No users found",
    "deleteConfirm": "Are you sure you want to delete this user?",
    "admin": "Admin",
    "operator": "Operator",
    "viewer": "Viewer",
    "roles": {
      "systemAdmin": "System Administrator",
      "facilityManager": "Healthcare Facility Manager",
      "departmentSupervisor": "Department Supervisor",
      "technician": "Medical Technician",
      "qualityManager": "Quality & Safety Manager",
      "infectionControl": "Infection Control Officer",
      "medicalMaintenance": "Medical Maintenance Officer",
      "pharmacist": "Pharmacist",
      "patientSafety": "Patient Safety Specialist",
      "monitor": "Monitor",
      "qualityAuditor": "Quality Auditor",
      "platformAdmin": "Platform Administrator"
    }
  },
  "profile": {
    "title": "Profile",
    "personalInfo": "Personal Information",
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "changePassword": "Change Password",
    "currentPassword": "Current Password",
    "newPassword": "New Password",
    "confirmPassword": "Confirm Password",
    "updateProfile": "Update Profile",
    "passwordChanged": "Password changed successfully"
  },
  "settings": {
    "title": "Settings",
    "general": "General",
    "language": "Language",
    "theme": "Theme",
    "light": "Light",
    "dark": "Dark",
    "system": "System",
    "notifications": "Notifications",
    "pushNotifications": "Push Notifications",
    "emailNotifications": "Email Notifications",
    "alarmNotifications": "Alarm Notifications",
    "account": "Account",
    "about": "About",
    "version": "Version",
    "privacy": "Privacy",
    "terms": "Terms and Conditions",
    "support": "Support"
  },
  "reports": {
    "title": "Reports",
    "generate": "Generate Report",
    "dateRange": "Date Range",
    "from": "From",
    "to": "To",
    "deviceReport": "Device Report",
    "alarmReport": "Alarm Report",
    "userReport": "User Report",
    "export": "Export",
    "pdf": "PDF",
    "excel": "Excel"
  },
  "sensor_provisioning": {
    "scan_barcode": "Scan Sensor Barcode",
    "detection_result": "Detection Result",
    "unmapped_sensors": "Unmapped Sensors",
    "device_config": "Device Configuration",
    "success_title": "Device Created Successfully!",
    "scan_instruction": "Scan sensor barcode (20 digits)",
    "scan_button": "Scan Barcode",
    "or_view_list": "Or view unmapped sensors list",
    "scanning": "Scanning...",
    "invalid_serial": "Invalid serial number",
    "serial_must_be_20": "Serial number must be exactly 20 digits",
    "detection_error": "Detection error",
    "detected_sensor": "Sensor Detected",
    "gateway_info": "Gateway Information",
    "sensor_info": "Sensor Information",
    "sensor_number": "Sensor Number",
    "sensor_type": "Sensor Type",
    "manufacturer": "Manufacturer",
    "protocol": "Protocol",
    "next_configure": "Next: Configure",
    "no_unmapped_sensors": "No unmapped sensors",
    "add_sensor_via_scan": "Add a new sensor by scanning",
    "refresh_list": "Refresh List",
    "loading_sensors": "Loading sensors...",
    "serial_number": "Serial Number",
    "last_seen": "Last Seen",
    "configure_sensor": "Configure Sensor",
    "device_information": "Device Information",
    "device_name": "Device Name",
    "device_name_placeholder": "e.g., Warehouse A Temperature Sensor",
    "select_zone": "Select Zone",
    "zone_optional": "Optional",
    "alarm_rules": "Alarm Rules",
    "high_threshold": "High Threshold",
    "low_threshold": "Low Threshold",
    "hysteresis": "Hysteresis",
    "debounce_seconds": "Debounce (seconds)",
    "cooldown_minutes": "Cooldown (minutes)",
    "severity": "Severity",
    "enable_notifications": "Enable Notifications",
    "severity_low": "Low",
    "severity_medium": "Medium",
    "severity_high": "High",
    "severity_critical": "Critical",
    "alarm_rules_explanation": "Alarm rules control when alerts are triggered",
    "hysteresis_explanation": "Temperature difference to return to normal",
    "debounce_explanation": "Time delay before confirming alarm",
    "cooldown_explanation": "Time between consecutive alarms",
    "configuration_summary": "Configuration Summary",
    "save_and_provision": "Save and Provision Device",
    "provisioning": "Provisioning...",
    "validation_device_name": "Device name is required",
    "validation_zone": "Zone must be selected",
    "validation_high_threshold": "High threshold is required",
    "validation_low_threshold": "Low threshold is required",
    "validation_thresholds_invalid": "High threshold must be greater than low threshold",
    "provisioning_failed": "Device provisioning failed",
    "mqtt_credentials": "MQTT Connection Credentials",
    "mqtt_broker": "MQTT Broker",
    "mqtt_port": "Port",
    "mqtt_username": "Username",
    "mqtt_password": "Password",
    "mqtt_client_id": "Client ID",
    "show_password": "Show Password",
    "hide_password": "Hide Password",
    "copy_password": "Copy Password",
    "password_copied": "Password copied to clipboard",
    "setup_instructions": "Setup Instructions",
    "instruction_1": "1. Open WES X280 Gateway interface",
    "instruction_2": "2. Go to: Point Management → Northbound Channel",
    "instruction_3": "3. Create new MQTT channel and enter credentials above",
    "instruction_4": "4. Link datapoints to channel and enable publishing",
    "next_steps": "Next Steps",
    "view_device_dashboard": "View Device Dashboard",
    "back_to_dashboard": "Back to Main Dashboard",
    "connection_details": "Connection Details",
    "sensor_temperature": "Temperature",
    "sensor_humidity": "Humidity",
    "sensor_pressure": "Pressure",
    "sensor_co2": "Carbon Dioxide",
    "unit_celsius": "Celsius",
    "unit_fahrenheit": "Fahrenheit",
    "unit_percent": "Percent",
    "unit_ppm": "Parts per million"
  },
  "errors": {
    "networkError": "Network connection error",
    "serverError": "Server error",
    "unauthorized": "Unauthorized",
    "forbidden": "Forbidden",
    "notFound": "Not found",
    "validationError": "Validation error",
    "unknownError": "Unknown error"
  }
}
